import React, { useCallback, useContext, useState } from 'react';
import { IconClose } from '@prisjakt/ui/icon';
import { AppContext } from '@prisjakt/ui-app-context';
import ReportModal from './report-modal';
import { StockStatus } from 'src/types';
import { PromptTitle, ReportOverlay, ToggleButtons } from './styles';
import { IconButton, ButtonSize } from '@prisjakt/ui/button/variants';

interface IReportButton {
  onClose: () => void;
  priceValue?: number | null;
  priceId?: string | null;
  productName?: string | null;
  stockStatus?: StockStatus | null;
}

export const ReportButton: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IReportButton>
>> = props => {
  const { onClose, priceValue, stockStatus, priceId, productName } = props;
  const { t } = useContext(AppContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleOnClose = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      onClose();
    },
    [onClose]
  );

  const openModal = useCallback(
    (e: React.MouseEvent) => {
      // Stops the PriceRow link and onClick from firing
      e.preventDefault();
      e.stopPropagation();

      setModalIsOpen(true);
    },
    [setModalIsOpen]
  );

  const closeModal = useCallback(() => setModalIsOpen(false), [setModalIsOpen]);

  return (
    <>
      <ReportModal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        onClose={onClose}
        priceId={priceId}
        priceValue={priceValue}
        productName={productName}
        stockStatus={stockStatus}
      />

      <ReportOverlay>
        <PromptTitle>
          {t('feedback', 'dialog.prompt-title')}

          <ToggleButtons type="button" onClick={openModal}>
            {t('feedback', 'dialog.prompt-button')}
          </ToggleButtons>
        </PromptTitle>

        <IconButton onClick={handleOnClose} size={ButtonSize.SMALL}>
          <IconClose />
        </IconButton>
      </ReportOverlay>
    </>
  );
};
